import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { isShopSessionView, useSession } from '../../../../infra/session';
import { BarberPayments } from './barber-payments';
import { selector } from '../../../../../app/main/barbers/formBarbers/barberForm/helpers';
export var BarberPaymentsContainer = function (_a) {
    var formSectionName = _a.formSectionName;
    var session = useSession().data;
    var isShopView = isShopSessionView(session === null || session === void 0 ? void 0 : session.view);
    var store = useStore();
    var fieldPrefix = formSectionName ? "".concat(formSectionName, ".") : '';
    var barberName = selector(store.getState(), "".concat(fieldPrefix, "firstName"));
    return _jsx(BarberPayments, { showRentCollect: isShopView, showCommissions: isShopView, barberName: barberName });
};
